<template>
    <div class="spinner-border" :class="sizeClass" role="status">
        <span class="visually-hidden">{{ statusText }}</span>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            validator: value => ['small', 'standard', 'large'].includes(value),
            default: 'standard'
        },

        status: {
            type: String,
            validator: value => ['loading', 'saving'].includes(value),
            default: 'loading'
        }
    },

    computed: {
        sizeClass() {
            let result = '';
            switch(this.size) {
                case 'small':
                    result = 'spinner-border-sm';
                    break;
                case 'large':
                    result = 'spinner-border-lg';
                    break;
            }
            return result;
        },

        statusText() {
            let result = 'Loading...';
            switch(this.status) {
                case 'saving':
                    result = 'Saving...';
            }
            return result;
        }
    }
}
</script>